const OnReviewIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_370_2230)">
        <path
          d="M8.3749 8.25005V4.22505C8.3749 3.92505 8.1249 3.67505 7.8249 3.67505C7.5249 3.67505 7.2749 3.92505 7.2749 4.22505V8.47505C7.2749 8.62505 7.3249 8.77505 7.4249 8.87505L10.1999 11.7C10.2999 11.8 10.4499 11.875 10.5999 11.875C10.7499 11.875 10.8749 11.825 10.9999 11.725C11.2249 11.5 11.2249 11.15 10.9999 10.925L8.3749 8.25005Z"
          fill="#00629B"
        />
        <path
          d="M7.99995 0.375C3.82495 0.375 0.449951 3.8 0.449951 8C0.449951 12.2 3.84995 15.625 7.99995 15.625C12.15 15.625 15.55 12.2 15.55 8C15.55 3.8 12.175 0.375 7.99995 0.375ZM7.99995 14.5C4.44995 14.5 1.54995 11.575 1.54995 8C1.54995 4.425 4.44995 1.5 7.99995 1.5C11.55 1.5 14.45 4.425 14.45 8C14.45 11.575 11.55 14.5 7.99995 14.5Z"
          fill="#00629B"
        />
      </g>
      <defs>
        <clipPath id="clip0_370_2230">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OnReviewIcon;
